import { createContext, useContext, useState, useCallback } from "react";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [presetPackage, setPresetPackage] = useState(null);

  const openBooking = useCallback((pkg = null) => {
    setPresetPackage(pkg);
    setOpen(true);
  }, []);

  return (
    <BookingContext.Provider value={{ open, setOpen, openBooking, presetPackage }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
};
